import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, Home } from 'lucide-react';
import Header from '../components/Header';

const CheckoutCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="max-w-2xl mx-auto px-4 py-16">
        <Card className="p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="rounded-full bg-orange-100 p-4">
              <XCircle size={64} className="text-orange-600" />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Pagamento Cancelado
          </h1>
          
          <p className="text-gray-600 mb-8">
            Seu pagamento foi cancelado. Nenhuma cobrança foi realizada.
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
            <h3 className="font-semibold text-gray-800 mb-2">O que fazer agora?</h3>
            <ul className="text-left text-sm text-gray-700 space-y-2">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Se você teve algum problema, pode tentar novamente.</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Se preferir, pode entrar em contato conosco para mais informações.</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Seus dados de cadastro foram salvos e estão seguros.</span>
              </li>
            </ul>
          </div>

          <div className="flex gap-4 justify-center">
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              className="px-8"
            >
              <ArrowLeft size={20} className="mr-2" />
              Tentar Novamente
            </Button>
            <Button
              onClick={() => navigate('/')}
              className="bg-[#00A86B] hover:bg-[#008c5a] text-white px-8"
            >
              <Home size={20} className="mr-2" />
              Voltar para Home
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default CheckoutCancel;
